module.exports = __webpack_public_path__ + "SB.png?5550c69a9028903f36649af8f73dece4";